import { Spinner } from "~/jose_modern/spinner";

export const TABLE_WRAPPER_ID = "#inventory-table-wrapper";
export const CHANGED_ACTUAL_CLASS = "changed-actual";

export const URL_QUERY_PARAMS = new Set([
  "sort_column",
  "sort_direction",
  "search",
  "include_archived",
  "ingredient_tags[]", // RM only (array param)
  "ingredient_tag", // RM only (backward compat)
  "supplier_filter_id", // RM only
  "recipe_tags[]", // FG only (array param)
  "recipe_tag", // FG only (backward compat)
  "adjustment_type",
  "page",
]);

export const startSpinner = () => {
  const el = document.querySelector(TABLE_WRAPPER_ID);
  if (el) Spinner.start(el);
};

export const stopSpinner = () => {
  const el = document.querySelector(TABLE_WRAPPER_ID);
  if (el) Spinner.stop(el);
};
